module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.fileList), function(item) {
    return _c('div', {
      staticClass: "demo-upload-list"
    }, [(item.status === 'finished') ? [_c('img', {
      attrs: {
        "width": "100px",
        "src": item.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "demo-upload-list-cover"
    }, [_c('Icon', {
      attrs: {
        "type": "ios-eye-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleView(item)
        }
      }
    }), _vm._v(" "), _c('Icon', {
      attrs: {
        "type": "ios-trash-outline"
      },
      nativeOn: {
        "click": function($event) {
          return _vm.handleRemove(item)
        }
      }
    })], 1)] : [(item.showProgress) ? _c('Progress', {
      attrs: {
        "percent": item.percentage,
        "hide-info": ""
      }
    }) : _vm._e()]], 2)
  }), _vm._v(" "), _c('Upload', {
    ref: "upload",
    staticStyle: {
      "display": "inline-block",
      "width": "58px"
    },
    attrs: {
      "with-credentials": true,
      "headers": _vm.headers,
      "data": _vm.data,
      "show-upload-list": false,
      "default-file-list": _vm.defaultFileList,
      "on-success": _vm.onSuccess,
      "accept": "image/*",
      "before-upload": _vm.beforeUpload,
      "type": "drag",
      "action": _vm.action,
      "multiple": false
    }
  }, [_c('div', {
    staticStyle: {
      "width": "58px",
      "height": "58px",
      "line-height": "58px"
    }
  }, [_c('Icon', {
    attrs: {
      "type": "ios-cloud-upload-outline",
      "size": "20"
    }
  }, [_vm._v("Select the file to upload")])], 1)]), _vm._v(" "), _c('Modal', {
    attrs: {
      "title": "View Image"
    },
    model: {
      value: (_vm.visible),
      callback: function($$v) {
        _vm.visible = $$v
      },
      expression: "visible"
    }
  }, [(_vm.visible) ? _c('img', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": _vm.showImageUrl
    }
  }) : _vm._e()])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-77ba850e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MultiUpload.vue
// module id = 1893
// module chunks = 8